// extracted by mini-css-extract-plugin
module.exports = {"chart":"BarChart_chart__Rpnf1","bar":"BarChart_bar__sUin0"};